import { atom } from 'jotai';

import type { PreviewPatch } from '@modules/business-manager/types/business-manager';

/**
 * Field-level overrides pushed in from the Business Manager, applied over the
 * layout loader's payload until a real revalidation replaces them.
 *
 * Only ever populated inside the preview iframe — on the public site nothing
 * dispatches a patch, so every read is an empty object and costs nothing.
 */
export const previewPatchAtom = atom<PreviewPatch>({});
